import FlexSearch from 'flexsearch';
import { STOP_WORDS } from './stopwords.tsx';

export const SEARCH_SORT_SCORE_ALPHA = 'SEARCH_SORT_SCORE_ALPHA';

export const SEARCH_SORT_ALPHA_ASC = 'SEARCH_SORT_ALPHA_ASC';

export const SEARCH_SORT_ALPHA_DESC = 'SEARCH_SORT_ALPHA_DESC';

// Defines per field index config
const SEARCH_FIELDS = [
  {
    field: 'name',
  },
  {
    field: 'teReoName',
  },
  {
    field: 'shortName',
  },
  {
    field: 'type',
  },
  {
    field: 'description',
  },
  {
    field: 'outline',
  },
  {
    field: 'responsibilities',
  },
  {
    field: 'dataRecords',
  },
  {
    field: 'legislation',
  },
  {
    field: 'frequentlyRequestedInfo',
  },
  {
    field: 'otherData',
  },
];

// Define the per field boost
const SEARCH_FIELD_BOOST = {
  name: 1,
  teReoName: 1,
  shortName: 1,
  type: 0.5,
  description: 0.5,
  outline: 0.2,
  responsibilities: 0.2,
  dataRecords: 0.2,
  legislation: 0.2,
  frequentlyRequestedInfo: 0.5,
  otherData: 0.1,
};

export function createIndex(data: object) {
  const index = new FlexSearch.Document({
    tokenize: 'forward',
    context: true,
    id: 'id',
    index: SEARCH_FIELDS,
    store: true,
    filter: STOP_WORDS,
    matcher: { ā: 'a', ē: 'e', ī: 'i', ō: 'o', ū: 'u' },
  });

  data.forEach((value) => index.add(value));

  return index;
}

export function search(
  index: any,
  term: string,
  sort: string = null,
  allWhenEmptyTerm: bool = true, // When the search term is empty, return all data in the index
) {
  const rankedResults = {};
  let results = [];

  if (term) {
    // Transform raw results into map from key -> { score, data }.
    index.search(term).forEach((value) => {
      value.result.forEach((key) => {
        if (!rankedResults.hasOwnProperty(key)) {
          rankedResults[key] = {
            score: 0,
            data: index.get(key),
          };
        }

        rankedResults[key].score += SEARCH_FIELD_BOOST[value.field];
      });
    });

    results = Object.values(rankedResults);
  } else if (allWhenEmptyTerm) {
    results = Object.values(index.store).map((value) => ({
      score: 1,
      data: value,
    }));
  }

  // Sort by score and then by canonicalName ascending
  let sortFunc = (a, b) =>
    b.score - a.score ||
    a.data.canonicalName.localeCompare(b.data.canonicalName);

  switch (sort) {
    // Sort by canonicalName ascending
    case SEARCH_SORT_ALPHA_ASC:
      sortFunc = (a, b) =>
        a.data.canonicalName.localeCompare(b.data.canonicalName);

      break;
    // Sort by canonicalName descending
    case SEARCH_SORT_ALPHA_DESC:
      sortFunc = (a, b) =>
        b.data.canonicalName.localeCompare(a.data.canonicalName);

      break;
  }

  return results.sort(sortFunc);
}
